import React, { useEffect, useState } from "react";
import Footer from "../../Components/Footer/footer";
import performRequest from "../../api/request";
import { Toast } from "../../CustomComponent/toast";
import LoadingPage from "../../Components/layouts/loading";
import getFilteredURL from "../../Components/Functions/filters.getUrl";
import DynamicFilterInput from "../../Components/layouts/filter.inpit";
import Pagination from "../../Components/layouts/pagination";
import { useSelector } from "react-redux";
import { FcInTransit } from "react-icons/fc";
import { BsJournalArrowUp } from "react-icons/bs";
import LtcBuyerTable from "./Buyers Management/ltc_buyer_table";
import { CustomErrorResponse } from "../../CustomComponent/custom_error_response";
import CustomViedoCard from "../../CustomComponent/custom_viedo_card";

function Longtermcontract() {
  const user = useSelector((store) => store.login.user);
  const role = useSelector((store) => store.login.user.Role);
  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [page, setPage] = useState(1);
  const [showPage, setShowPage] = useState(1);
  const [data, setData] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [favBuyer, setFavBuyer] = useState();
  let [filters, setFilters] = useState({
    name: "",
  });
  const [projectData, setProjectData] = useState(null);
  const [isHandOverCompleted, setIsHandOverCompleted] = useState(false);

  useEffect(() => {
    performRequest("GET", "/handOver/getHandOver/")
      .then((res) => {
        if (res.status === 200) {
          if (res?.data?.handOverData?.length > 0) {
            setIsHandOverCompleted(true);
          } else {
            setIsHandOverCompleted(false);
          }
        } else {
          Toast("error", "Error while getting data!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  }, [refresh, page]);

  useEffect(() => {
    if (role === process.env.REACT_APP_ROLE_CLIENT) {
      performRequest(
        "GET",
        `/projectTracking/getProjectTracking?name=${user?.Name}`
      )
        .then((res) => {
          if (res.status === 200) {
            setProjectData(res.data);
          } else {
            Toast("error", "Error while getting data!");
          }
        })
        .catch((err) => {
          // Toast("error", "Server Error!");
          // console.error(err);
          CustomErrorResponse(err);
        });
    }
  }, [role, user?.Name]);

  useEffect(() => {
    filters = { ...filters, userId: user?.UserId };
    setLoading(true);
    performRequest(
      "GET",
      getFilteredURL("/buyerProfiles/getLtcbuyerProfiles/", page, filters)
    )
      .then((res) => {
        if (res.status === 200) {
          setData(res?.data?.buyerProfileData);
          setTotalPages(Math.ceil(res?.data?.buyerProfileCount / 50));
        } else {
          Toast("error", "Error while getting Buyers!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [refresh, page]);
  useEffect(() => {
    setLoading(true);
    performRequest(
      "GET",
      getFilteredURL("/favoriteBuyer/getAllFavoriteBuyer/", page, filters)
    )
      .then((res) => {
        if (res.status === 200) {
          setFavBuyer(res?.data?.favoriteBuyers);
        } else {
          Toast("error", "Error while getting Buyers!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [refresh]);

  if (loading) {
    return <LoadingPage />;
  }
  const projectDataTrak = projectData?.projectTrackingData;

  const workOrder = projectDataTrak?.[0]?.workOrderUpload;

  return (
    <>
      {!workOrder &&
      !isHandOverCompleted &&
      role === process.env.REACT_APP_ROLE_CLIENT ? (
        <div className="page-wrapper">
          <div className="page-body">
            <div className="container-xxl d-flex flex-column justify-content-center">
              <div className="empty">
                <p className="empty-title">
                  {!isHandOverCompleted && workOrder
                    ? "Your farm handover is not completed yet."
                    : "Your farm has not been deployed yet."}
                </p>
                <p className="empty-subtitle text-muted">
                  Contact your account manager.
                </p>
              </div>
            </div>
          </div>

          <Footer />
        </div>
      ) : (
        <div className="page">
          <div className="page-wrapper">
            <div className="container-xxl">
              <div className="page-header d-print-none mb-2">
                <div className="row align-items-center">
                  <div className="col-md-8">
                    <h2 className="page-title mb-1">
                      {/* <FcInTransit className="fs-2  me-1" /> Long term contract */}
                      <FcInTransit className="fs-2  me-1" /> Direct Requirement
                    </h2>
                    <h4 className="text-muted p-0 m-0">
                      {/* <StepRoutes /> */} Connect and sale your produce to
                      this buyers.
                    </h4>
                  </div>
                  <div className="col-md-4">
                    <div className="btn-list justify-content-end">
                      {process.env.REACT_APP_ROLE_ADMIN === user.Role ||
                      process.env.REACT_APP_ROLE_ADMIN_S === user.Role ||
                      process.env.REACT_APP_ROLE_SALESCOORDINATOR ===
                        user.Role ? (
                        <a href={"/buyers-management/new"}>
                          <button className="btn btn-primary d-none d-md-block d-lg-block d-xl-block">
                            <BsJournalArrowUp className="me-2 fs-2" /> ADD NEW
                            BUYER
                          </button>
                        </a>
                      ) : (
                        <></>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-3 col-sm-12 py-2">
                  <div className="card p-2">
                    <div
                      id="faq-1"
                      className="accordion"
                      role="tablist"
                      aria-multiselectable="true"
                    >
                      <div>
                        <div className="accordion-header m-0" role="tab">
                          <button
                            className="accordion-button fs-3 d-md-none p-0"
                            data-bs-toggle="collapse"
                            data-bs-target="#faq-1-1"
                          >
                            <h3 className="m-1">Filter result</h3>
                          </button>
                        </div>

                        <div
                          id="faq-1-1"
                          className="accordion-collapse collapse d-md-none"
                          role="tabpanel"
                          data-bs-parent="#faq-1"
                        >
                          <div className="accordion-body pt-0">
                            <div className="row">
                              <div className="col-12">
                                <DynamicFilterInput
                                  label="Search name:"
                                  value={filters.name}
                                  onChange={(e) =>
                                    setFilters({
                                      ...filters,
                                      name: e.target.value,
                                    })
                                  }
                                  placeholder="search name..."
                                  type="text"
                                />
                              </div>
                              {/* <div className="col-12">
                                <DynamicFilterSelect
                                  label="Search States:"
                                  value={filters.addressState}
                                  onChange={(e) =>
                                    setFilters({
                                      ...filters,
                                      addressState: e.target.value,
                                    })
                                  }
                                >
                                  <option value="">Search Entire India</option>

                                  {states &&
                                    states?.map((state, index) => (
                                      <option key={index} value={state?.name}>
                                        {state?.name}
                                      </option>
                                    ))}
                                </DynamicFilterSelect>
                              </div> */}
                              {/* <div className="col-12">
                                <DynamicFilterSelect
                                  label="Search Buyer Type:"
                                  value={filters.buyerType}
                                  onChange={(e) =>
                                    setFilters({
                                      ...filters,
                                      buyerType: e.target.value,
                                    })
                                  }
                                >
                                  <option value="">All Type</option>
                                  <option value="isExporter">Exporter</option>
                                  <option value="isWholesaler">
                                    Wholesaler
                                  </option>
                                  <option value="isTrader">Trader</option>
                                  <option value="isRetailer">Retailer</option>
                                  <option value="isFoodProcessor">
                                    Food Processor
                                  </option>
                                </DynamicFilterSelect>
                              </div> */}
                              {/* <div className="col-12">
                                <label class="form-check">
                                  <input
                                    class="form-check-input"
                                    type="checkbox"
                                    checked={filters.favouritesOnly}
                                    onChange={(e) => {
                                      setFilters({
                                        ...filters,
                                        favouritesOnly: e.target.checked,
                                      });
                                    }}
                                    style={{
                                      textAlign: "center",
                                      height: "20px",
                                      width: "20px",
                                    }}
                                  />
                                  <span class="form-check-label">
                                    My Favorite Buyers
                                  </span>
                                </label>
                              </div> */}

                              <div className="col-12">
                                <div className="row mt-2">
                                  <div className="col-6">
                                    <button
                                      onClick={() => setRefresh(!refresh)}
                                      className="btn btn-success w-100"
                                    >
                                      Apply Filter
                                    </button>
                                  </div>
                                  <div className="col-6">
                                    <button
                                      onClick={() => {
                                        setFilters({
                                          name: "",
                                          addressState: "",
                                          buyerType: "",
                                          favouritesOnly: false,
                                          userId: "",
                                        });
                                        setPage(1);
                                        setRefresh(!refresh);
                                      }}
                                      className="btn btn-secondary w-100"
                                    >
                                      Reset Filter
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="accordion-body d-none d-md-block">
                          <div className="row">
                            <h3>Filter result</h3>
                            <div className="col-12">
                              <DynamicFilterInput
                                label="Search name:"
                                value={filters.name}
                                onChange={(e) =>
                                  setFilters({
                                    ...filters,
                                    name: e.target.value,
                                  })
                                }
                                placeholder="search name..."
                                type="text"
                              />
                            </div>
                            {/* <div className="col-12">
                              <DynamicFilterSelect
                                label="Search States:"
                                value={filters.addressState}
                                onChange={(e) =>
                                  setFilters({
                                    ...filters,
                                    addressState: e.target.value,
                                  })
                                }
                              >
                                <option value="">Search Entire India</option>

                                {states &&
                                  states?.map((state, index) => (
                                    <option key={index} value={state?.name}>
                                      {state?.name}
                                    </option>
                                  ))}
                              </DynamicFilterSelect>
                            </div> */}
                            {/* <div className="col-12">
                              <DynamicFilterSelect
                                label="Search Buyer Type:"
                                value={filters.buyerType}
                                onChange={(e) =>
                                  setFilters({
                                    ...filters,
                                    buyerType: e.target.value,
                                  })
                                }
                              >
                                <option value="">All Type</option>
                                <option value="isExporter">Exporter</option>
                                <option value="isWholesaler">Wholesaler</option>
                                <option value="isTrader">Trader</option>
                                <option value="isRetailer">Retailer</option>
                                <option value="isFoodProcessor">
                                  Food Processor
                                </option>
                              </DynamicFilterSelect>
                            </div> */}
                            {/* <div className="col-12">
                              <label class="form-check">
                                <input
                                  class="form-check-input"
                                  type="checkbox"
                                  checked={filters.favouritesOnly}
                                  onChange={(e) => {
                                    setFilters({
                                      ...filters,
                                      favouritesOnly: e.target.checked,
                                    });
                                  }}
                                  style={{
                                    textAlign: "center",
                                    height: "20px",
                                    width: "20px",
                                  }}
                                />
                                <span class="form-check-label">
                                  My Favorite Buyers
                                </span>
                              </label>
                            </div> */}

                            <div className="col-12">
                              <div className="row mt-2">
                                <div className="col-lg-6 col-md-12">
                                  <button
                                    onClick={() => setRefresh(!refresh)}
                                    className="btn btn-success w-100"
                                  >
                                    Apply Filter
                                  </button>
                                </div>
                                <div className="col-lg-6 col-md-12 mt-lg-0 mt-md-2">
                                  <button
                                    onClick={() => {
                                      setFilters({
                                        name: "",
                                        // addressState: "",
                                        // buyerType: "",
                                        // favouritesOnly: false,
                                        // userId: "",
                                      });
                                      setPage(1);
                                      setRefresh(!refresh);
                                    }}
                                    className="btn btn-secondary w-100"
                                  >
                                    Reset Filter
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="d-none d-lg-block d-md-block">
                    <CustomViedoCard
                      viedoLink={"https://www.youtube.com/embed/Qp1uFEAuyCA"}
                      id={"model-viedo"}
                      name={"long term contract"}
                    ></CustomViedoCard>
                  </div>
                  <div className="card mt-2 border-0">
                    <div className="card-body p-0">
                      <img
                        className="d-none d-sm-block"
                        src="https://res.cloudinary.com/bsgfcooa/image/upload/v1752556072/1_vyhuj0_b1uh26_tcvj3t.jpg"
                        alt="plantvisittoday"
                      />
                    </div>
                  </div>
                </div>

                <div className="col-md-9 col-sm-12 py-2">
                  <div className="card">
                    {data && favBuyer && user && (
                      <LtcBuyerTable
                        filters={filters}
                        buyers={data}
                        favBuyer={favBuyer}
                        refresh={refresh}
                        userId={user.UserId}
                        setRefresh={setRefresh}
                      />
                    )}

                    <div className="btn-list justify-content-center">
                      <div className="d-lg-none d-md-none mt-3 mb-3">
                        <span
                          data-bs-toggle="modal"
                          data-bs-target="#modal-team"
                        >
                          {process.env.REACT_APP_ROLE_ADMIN === user.Role ||
                          process.env.REACT_APP_ROLE_ADMIN_S === user.Role ? (
                            <a href={"/buyers-management/new"}>
                              <button className="btn btn-primary d-block d-lg-none d-md-none d-xl-block">
                                <BsJournalArrowUp className="me-2 fs-2" /> ADD
                                NEW BUYER
                              </button>
                            </a>
                          ) : (
                            <></>
                          )}
                        </span>
                      </div>
                    </div>

                    <Pagination
                      page={page}
                      setPage={setPage}
                      totalPages={totalPages}
                      pageDatalength={data?.length || 0}
                      showPage={showPage}
                      setShowPage={setShowPage}
                    />
                  </div>
                  <div className="card mt-2 border-0">
                    <div className="card-body p-0">
                      <img
                        className="d-block d-sm-none"
                        src="https://res.cloudinary.com/bsgfcooa/image/upload/v1752556072/1_vyhuj0_b1uh26_tcvj3t.jpg"
                        alt="plantvisittoday"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="d-block d-md-none d-lg-none">
                <CustomViedoCard
                  viedoLink={"https://www.youtube.com/embed/Qp1uFEAuyCA"}
                  id={"model-viedo2"}
                  name={"long term contract"}
                ></CustomViedoCard>
              </div>
              <div className="page-body">
                <div className="container-xl"></div>
              </div>
            </div>
            <Footer />
          </div>
        </div>
      )}
    </>
  );
}

export default Longtermcontract;
